import * as SalesStore from '../SalesStore';
import { Result } from 'core/infrastructure';
import makeNewTicketReadyToSale from './makeTicketReadyToSale';
import startTakeOutOrderIfNeeded from '../utils/startTakeOutOrderIfNeeded';

export default async function createNewTicket() {

	const previousTicket = SalesStore.getTicket();

	const restorePreviousTicket = async () => {
		await SalesStore.release();
		await SalesStore.loadTicketById(previousTicket.Id);
	};

	await SalesStore.release();
	await SalesStore.createNewTicket(previousTicket.Location);

	if (!await makeNewTicketReadyToSale({
		getTicket: SalesStore.getTicket,
		setTableCompanions: SalesStore.setTableCompanions,
		setFriendlyName: SalesStore.setFriendlyName,
	})) {
		await restorePreviousTicket();
		return Result.error();
	}

	const startTakeOutOrderIfNeededResult = await startTakeOutOrderIfNeeded(SalesStore.getTicket());
	if (!startTakeOutOrderIfNeededResult.ok) {
		await SalesStore.release();
		await restorePreviousTicket();
		return Result.error();
	}

	return Result.ok();
}
